import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import classes from "./Overview.module.css";
import { useArchiveStudio } from '../../hooks/useArchiveStudio';
import { SmallModal } from "../UI/SmallModal/SmallModal";
import { extractStudioTagValues } from "../../util/tagsHelper";
import { notifyDeleteError, notifyErrorToast, notifyValidationToast } from '../../util/notifyActionError';

const HOUSE_RULE_COPY = {
    smokingAllowed: {
        allowed: "Rauchen erlaubt",
        blocked: "Rauchen nicht erlaubt",
    },
    alcoholAllowed: {
        allowed: "Alkohol erlaubt",
        blocked: "Alkohol nicht erlaubt",
    },
    foodAllowed: {
        allowed: "Essen erlaubt",
        blocked: "Essen nicht erlaubt",
    },
    adultContentAllowed: {
        allowed: "Adult Content erlaubt",
        blocked: "Adult Content nicht erlaubt",
    },
    fogMachineAllowed: {
        allowed: "Nebelmaschine erlaubt",
        blocked: "Nebelmaschine nicht erlaubt",
    },
    glitterConfettiAllowed: {
        allowed: "Glitzer/Konfetti erlaubt",
        blocked: "Glitzer/Konfetti nicht erlaubt",
    },
    pyrotechnicsAllowed: {
        allowed: "Pyrotechnik erlaubt",
        blocked: "Pyrotechnik nicht erlaubt",
    },
    equipmentChangesAllowed: {
        allowed: "Equipment-Änderungen erlaubt",
        blocked: "Equipment-Änderungen nicht erlaubt",
    },
};

const DAY_LABELS = {
    0: "So",
    1: "Mo",
    2: "Di",
    3: "Mi",
    4: "Do",
    5: "Fr",
    6: "Sa",
    7: "So",
};

const DAY_ORDER = [1, 2, 3, 4, 5, 6, 0];

const getPricingSummary = (studio) => {
    const pricingMode = studio?.pricingMode || "HOURLY";
    return pricingMode === "PACKAGES" ? ["Paketpreise"] : ["Stundenpreis"];
};

// const getHouseRulesSummary = (houseRules) => {
//     if (!houseRules) return ["Keine Hausregeln hinterlegt"];

//     const ruleLines = Object.entries(HOUSE_RULE_COPY)
//         .filter(([key]) => typeof houseRules[key] === "boolean")
//         .map(([key, copy]) => (houseRules[key] ? copy.allowed : copy.blocked));

//     const allowedCount = Object.keys(HOUSE_RULE_COPY).filter((key) => houseRules[key] === true).length;
//     const blockedCount = Object.keys(HOUSE_RULE_COPY).filter((key) => houseRules[key] === false).length;
//     const customRules = typeof houseRules.customRules === "string" && houseRules.customRules.trim()
//         ? "Zusatzregel vorhanden"
//         : "";

//     if (ruleLines.length === 0 && !customRules) return ["Keine Hausregeln hinterlegt"];

//     return [
//         `${allowedCount} erlaubt, ${blockedCount} nicht erlaubt`,
//         ...ruleLines.slice(0, 2),
//         customRules,
//     ].filter(Boolean);
// };

// const getPaidEquipmentSummary = (studio) => {
//     const items = Array.isArray(studio?.optionalBookableEquipment)
//         ? studio.optionalBookableEquipment
//         : [];

//     if (items.length === 0) return ["Kein kostenpflichtiges Equipment"];

//     const itemLines = items
//         .slice()
//         .sort((a, b) => Number(a?.sortOrder || 0) - Number(b?.sortOrder || 0))
//         .slice(0, 2)
//         .map((item) => {
//             const quantity = Number(item?.quantity || 1);
//             const name = item?.nameModel || item?.name || "Equipment";
//             const price = formatEuro(item?.pricePerPiece ?? item?.price);
//             return `${quantity}x ${name}${price ? ` - ${price}` : ""}`;
//         });

//     return [`${items.length} kostenpflichtige Items`, ...itemLines];
// };

// const getFreeEquipmentItems = (equipment) => {
//     const categories = Array.isArray(equipment?.items) ? equipment.items : [];
//     return categories.flatMap((category) =>
//         Array.isArray(category?.items)
//             ? category.items.map((item) => ({
//                   ...item,
//                   category: category.category,
//               }))
//             : []
//     );
// };

// const getFreeEquipmentSummary = (equipment) => {
//     const items = getFreeEquipmentItems(equipment).filter((item) => item?.name);
//     if (items.length === 0) return ["Kein kostenloses Equipment"];

//     const itemLines = items.slice(0, 2).map((item) => {
//         const count = Math.max(1, Number(item?.count || 1));
//         return `${count}x ${item.name}`;
//     });

//     return [`${items.length} kostenlose Items`, ...itemLines];
// };

// const normalizeAvailabilityDay = (dayOfWeek) => {
//     const day = Number(dayOfWeek);
//     return day === 7 ? 0 : day;
// };

// const formatDayRange = (days) => {
//     if (days.length === 1) return DAY_LABELS[days[0]];
//     return `${DAY_LABELS[days[0]]}-${DAY_LABELS[days[days.length - 1]]}`;
// };

// const getAvailabilitySummary = (studio) => {
//     const availabilities = Array.isArray(studio?.availabilitiesList)
//         ? studio.availabilitiesList
//         : Array.isArray(studio?.availabilities?.items)
//             ? studio.availabilities.items.filter(Boolean)
//             : [];

//     if (availabilities.length === 0) return ["Keine Betriebszeiten hinterlegt"];

//     const byDay = new Map();
//     availabilities.forEach((availability) => {
//         const day = normalizeAvailabilityDay(availability?.dayOfWeek);
//         if (!DAY_LABELS[day] || !availability?.startTime || !availability?.endTime) return;
//         const slots = byDay.get(day) || [];
//         slots.push({
//             startTime: availability.startTime,
//             endTime: availability.endTime,
//         });
//         byDay.set(day, slots);
//     });

//     const daySummaries = DAY_ORDER
//         .filter((day) => byDay.has(day))
//         .map((day) => {
//             const slots = byDay
//                 .get(day)
//                 .slice()
//                 .sort((a, b) => a.startTime.localeCompare(b.startTime));
//             const is24Hours =
//                 slots.length === 1 &&
//                 slots[0].startTime === "00:00" &&
//                 (slots[0].endTime === "23:59" || slots[0].endTime === "24:00");
//             const label = is24Hours
//                 ? "24h"
//                 : slots
//                     .slice(0, 2)
//                     .map((slot) => `${slot.startTime}-${slot.endTime}`)
//                     .join(", ");
//             const extraSlots = !is24Hours && slots.length > 2 ? ` +${slots.length - 2}` : "";
//             return {
//                 day,
//                 label: `${label}${extraSlots}`,
//             };
//         });

//     if (daySummaries.length === 0) return ["Keine Betriebszeiten hinterlegt"];

//     const grouped = [];
//     daySummaries.forEach((summary) => {
//         const current = grouped[grouped.length - 1];
//         if (
//             current &&
//             current.label === summary.label &&
//             DAY_ORDER.indexOf(summary.day) === DAY_ORDER.indexOf(current.days[current.days.length - 1]) + 1
//         ) {
//             current.days.push(summary.day);
//             return;
//         }
//         grouped.push({ label: summary.label, days: [summary.day] });
//     });

//     const lines = grouped.slice(0, 3).map((group) => `${formatDayRange(group.days)}: ${group.label}`);
//     if (grouped.length > 3) {
//         lines.push(`+ ${grouped.length - 3} weitere Zeitgruppen`);
//     }
//     return lines;
// };

const OverviewFotoThumbnail = ({ src, alt }) => {
    const [loaded, setLoaded] = useState(() => !src);
    useEffect(() => {
        setLoaded(!src);
    }, [src]);

    return (
        <div className={classes.imageItem}>
            {!loaded && <div className={classes.fotoImageSkeleton} aria-hidden />}
            <img
                src={src || undefined}
                alt={alt}
                onLoad={() => setLoaded(true)}
                onError={() => setLoaded(true)}
                className={`${classes.fotoImage} ${loaded ? classes.fotoImageLoaded : classes.fotoImageLoading}`}
            />
        </div>
    );
};

const OverviewImagesCard = ({ processedImages, onCardClick }) => {
    return (
        <div className={classes.infosCard} onClick={() => onCardClick('fotos')}>
            <div className={classes.infos}>
                <h2 className="semiboldLarge">Fotos</h2>
                <div className={classes.imagesContainer}>
                    {processedImages?.slice(0, 3).map((image, index) => (
                        <OverviewFotoThumbnail
                            key={`${image}-${index}`}
                            src={image}
                            alt={`Studio image ${index + 1}`}
                        />
                    ))}
                </div>
            </div>
            <button className={classes.editStudioButton}>
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                    <path d="M8.00039 7.50742L7.60039 7.90742L1.50039 14.0074L0.400391 12.9074L5.80039 7.50742L0.400391 1.70742L1.60039 0.607422L8.00039 7.50742Z" fill="#696F76"/>
                </svg>
            </button>
        </div>
    )
}

const OverviewCard = ({ 
    title, 
    updateBox,
    summaryLines,
    infos, 
    infos2, 
    address, 
    postcode, 
    city, 
    country, 
    size, 
    capacity,
    price,
    minHours,
    onCardClick,
    componentId,
    studioTypes,
    amenities,
    studioTags,
    status
    }) => {

    const truncateText = (text, amenities = false) => {
        if (amenities === true) {
            if (!text || !Array.isArray(text)) return "";
            const joinedText = text.join(", ");
            if (joinedText.length <= 55) return joinedText;
            return joinedText.substring(0, 47) + "...";
        }
            
        if (text === null || text === undefined || text === "") return "";
        const stringValue = String(text);
        if (stringValue.length <= 75) return stringValue;
        return stringValue.substring(0, 72) + "...";
    };

    const getTagNames = (tags) => {
        return extractStudioTagValues(tags);
    };

    const truncatedInfos = truncateText(infos);
    const truncatedInfos2 = truncateText(infos2);
    const truncatedAmenities = truncateText(amenities, true);
    const tagNames = getTagNames(studioTags);
    const truncatedTags = truncateText(tagNames, true);
    const normalizedSummaryLines = Array.isArray(summaryLines)
        ? summaryLines.map((line) => truncateText(line)).filter(Boolean)
        : [];
    const normalizedStatus = typeof status === "string" ? status.toUpperCase() : "";
    const isStatusActive = normalizedStatus === "ACTIVE" || normalizedStatus === "PUBLISHED";
    const statusLabel = isStatusActive ? "Aktiv" : "Inaktiv";

    return (
        <div className={classes.infosCard} onClick={() => onCardClick(componentId)}>
            <div className={classes.infos}>
                <div className={classes.infosTitleContainer}>
                    <h2 className="semiboldLarge">{title}</h2>
                    {status &&
                    <div className={classes.statusTagContainer}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                            <circle cx="5" cy="5" r="5" fill={isStatusActive ? "#20BD13" : "#FF0000"}/>
                        </svg>
                        <span className="regularXxs">{statusLabel}</span>
                    </div>
                    }
                    {updateBox &&
                    <span className={`${classes.newUpdateContainer} semiboldXxs`}>
                        NEU
                    </span>
                    }
                </div>
                {normalizedSummaryLines.length > 0 &&
                <div className={classes.infosContent}>
                    {normalizedSummaryLines.map((line, index) => (
                        <p key={`${componentId}-summary-${index}`} className="regularMiddle">{line}</p>
                    ))}
                </div>
                }
                {normalizedSummaryLines.length === 0 && (infos || infos2) &&
                <div className={classes.infosContent}>
                    <p className="regularMiddle">{truncatedInfos}</p>
                    <p className="regularMiddle">{truncatedInfos2}</p>
                </div>
                }
                {normalizedSummaryLines.length === 0 && (address || postcode || city || country) &&
                <div className={classes.infosContent}>
                    <p className="regularMiddle">{address}</p>
                </div>
                }
                {normalizedSummaryLines.length === 0 && (size || capacity) &&
                <div className={classes.infosContent}>
                    <p className="regularMiddle">Größe: {size}</p>
                    <p className="regularMiddle">Kapazität: {capacity}</p>
                </div>
                }
                {normalizedSummaryLines.length === 0 && (price || minHours) &&
                <div className={classes.infosContent}>
                    <p className="regularMiddle">Preis: {price}</p>
                    <p className="regularMiddle">Stundenanzahl: {minHours}</p>
                </div>
                }
                {normalizedSummaryLines.length === 0 && studioTypes &&
                <div className={classes.infosContent}>
                    <p className="regularMiddle">{studioTypes.join(" & ")}</p>
                </div>
                }
                {normalizedSummaryLines.length === 0 && amenities &&
                <div className={classes.infosContent}>
                    <p className="regularMiddle">{truncatedAmenities}</p>
                </div>
                }
                {normalizedSummaryLines.length === 0 && studioTags &&
                <div className={classes.infosContent}>
                    <p className="regularMiddle">{truncatedTags}</p>
                </div>
                }
            </div>
            <button className={classes.editStudioButton}>
                <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                    <path d="M8.00039 7.50742L7.60039 7.90742L1.50039 14.0074L0.400391 12.9074L5.80039 7.50742L0.400391 1.70742L1.60039 0.607422L8.00039 7.50742Z" fill="#696F76"/>
                </svg>
            </button>
        </div>
  )
}

export const Overview = ({ studio, onCardClick, isMobileView, handleBackClick, onPreviewClick, setActiveComponent }) => { 
    const [open, setOpen] = useState(false);
    const [openPhoneModal, setOpenPhoneModal] = useState(false);
    const [modalTab, setModalTab] = useState(1);
    const [selectedOption, setSelectedOption] = useState("");
    const [textareaContent, setTextareaContent] = useState("");

    const { archiveStudio, checkForFutureBookings, loading: archiveLoading, fetchingStudio } = useArchiveStudio(studio?.id);
    
    const navigate = useNavigate();

    // Map backend enum values to frontend display names
    const getCancellationPolicyDisplayName = (policy) => {
        if (!policy) return "";
        const mapping = {
            'FLEXIBLE': 'Kulant',
            'STANDARD': 'Standard',
            'STRICT': 'Strikt'
        };
        return mapping[policy] || policy;
    };

    const navigateToStudio = () => {
        if (typeof onPreviewClick === "function") {
            onPreviewClick();
            return;
        }
        navigate(`/preview/studio/${studio?.id}`, {
            state: { from: 'editor' }
        })
    }
    
    const handleBackButtonClick = () => {
        if (typeof handleBackClick === "function") {
            handleBackClick();
            return;
        }
        navigate("/services-studios");
    };

    const handleEditStudioButtonClick = () => {
        navigate(`/services-studios/`);
    }

    const handleOpenModal = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
        setModalTab(1);
        setSelectedOption("");
        setTextareaContent("");
    }

    const moveToAvailiability = () => {
        navigate(`/services-studios/editor/${studio?.id}#availability`)
        setOpenPhoneModal(false);
        setOpen(false);
        setActiveComponent("availability")
    }

    const handleOptionSelect = (optionValue) => {
        setSelectedOption(optionValue);
    }

    const handleTextareaChange = (e) => {
        if (e.target.value.length <= 300) {
            setTextareaContent(e.target.value);
        }
    }

    const handleBackButtonModal = () => {
        setModalTab(1);
        setSelectedOption("");
        setTextareaContent("");
    }

    const handleOpenPhoneModal = () => {    
        setOpenPhoneModal(true);
    }

    const handleFinish = () => {
        setOpen(false);
        navigate("/services-studios");
    }

    const handleArchiveStudio = async (e) => {
        e.stopPropagation();
        
        if (!studio || !studio?.id) {
          notifyValidationToast('Studio konnte nicht gelöscht werden: Ungültige Studiodaten.', 'Löschen nicht möglich');
          return;
        }
      
        try {
          const bookingCheck = checkForFutureBookings(studio.id);

          if (bookingCheck.isLoading) {
            notifyErrorToast('Buchungsdaten werden noch geladen, bitte versuche es gleich erneut.', {
              title: 'Bitte warten',
            });
            return;
          }

          if (bookingCheck.success && bookingCheck.hasFutureBookings) {
            setModalTab(5);
            return;
          }

          const result = await archiveStudio(studio.id);
          if (result.success) {
            setModalTab(4);
          } else {
            notifyDeleteError(new Error(result.error || 'Studio konnte nicht gelöscht werden.'), {
              onRetry: () => handleArchiveStudio(e),
            });
          }
        } catch (error) {
          notifyDeleteError(error, { onRetry: () => handleArchiveStudio(e) });
        }
      };

    return (
    <div style={{zIndex : modalTab <= 1 ? 1 : 100 }} open={open} className={`${classes.overviewContainer} ${isMobileView ? classes.hiddenOnMobile : ''}`}>
        <header className={classes.overviewHeader}>
            <div className={classes.overviewHeaderLeft} onClick={handleEditStudioButtonClick}>
                <svg className={classes.backIcon} xmlns="http://www.w3.org/2000/svg" width="11" height="20" viewBox="0 0 11 20" fill="none">
                    <path fillRule="evenodd" clipRule="evenodd" d="M0 9.6255L8.99855 0.626953L10.2006 1.82903L2.35773 9.67193L10.2486 18.2204L8.99941 19.3734L0.0172915 9.64279L0 9.6255Z" fill="#1F1F1F"/>
                </svg>
                <h2 className="titleSemibold2">Studio-Editor</h2>
            </div>
            <button onClick={handleOpenModal} className={`${classes.deleteStudioButton} semiboldXs`}>Verwalten</button>
        </header>
        <header className={classes.phoneHeader}>
            <div onClick={handleBackClick} className={classes.overviewHeaderLeft}>
                <div className={classes.backButton}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="20" viewBox="0 0 11 20" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M0 9.6255L8.99855 0.626953L10.2006 1.82903L2.35773 9.67193L10.2486 18.2204L8.99941 19.3734L0.0172915 9.64279L0 9.6255Z" fill="#1F1F1F"/>
                    </svg>
                </div>
                <h2 className={`${classes.phoneTitle} titleSemibold2`}>Studio-Editor</h2>
                <h2 className={`${classes.smallPhoneTitle} titleSemibold2`}>Studio</h2>
            </div>
            <button onClick={handleOpenPhoneModal} className={`${classes.deleteStudioButton} semiboldXs`}>Verwalten</button>
        </header>
        <div className={classes.overviewContent}> 
          <div className={classes.overviewNavigation}>
            <button className={classes.overviewEditorButton}>
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M10.2677 0.218899C10.4864 -0.00160395 10.818 -0.0620039 11.0994 0.0673809C11.7073 0.346839 12.3619 0.837717 12.9315 1.37201C13.5042 1.90918 14.0426 2.53876 14.3952 3.13453C14.5692 3.42842 14.5229 3.8039 14.2829 4.04591L12.4929 5.84955C12.4725 5.87103 12.4518 5.89187 12.4308 5.9121L10.924 7.43048C10.5956 7.76165 10.2671 8.09293 9.93851 8.42426C8.22973 10.1474 6.51946 11.872 4.81334 13.5908C4.68551 13.7196 4.5145 13.7978 4.33412 13.809L1.28691 13.9986C1.07476 14.0118 0.867195 13.9325 0.716943 13.781C0.566691 13.6294 0.488211 13.4201 0.501438 13.2062L0.688077 10.1884C0.686336 9.99489 0.758695 9.80082 0.905154 9.65316L2.10469 8.44386C2.12213 8.42627 2.14023 8.40974 2.15891 8.39427L8.47034 2.03139C8.47518 2.02621 8.48009 2.0211 8.48508 2.01606C8.97303 1.52286 9.42015 1.07258 9.80213 0.687915C9.97071 0.51815 10.1266 0.361161 10.2677 0.218899ZM3.09409 9.56005L2.15369 10.5081L2.0333 12.4547L3.96273 12.3347L9.48221 6.77021C9.48206 6.77035 9.48235 6.77006 9.48221 6.77021L10.0111 6.23699C9.63378 6.07286 9.28631 5.8333 8.99425 5.56069C8.66366 5.25212 8.3695 4.86895 8.17534 4.44374L7.56699 5.05761C5.44743 7.19261 5.27549 7.36595 3.15774 9.5028C3.13746 9.52326 3.1162 9.54235 3.09409 9.56005ZM9.54288 3.0637C9.42298 3.20104 9.38427 3.366 9.44478 3.60337C9.51337 3.87247 9.70793 4.19003 10.0014 4.46398C10.2949 4.73794 10.6239 4.90899 10.8951 4.95715C11.1149 4.99616 11.268 4.95582 11.3898 4.84704C11.4101 4.82655 11.4305 4.80606 11.4508 4.78557C11.4514 4.78495 11.452 4.78433 11.4526 4.78372C11.4601 4.77619 11.4677 4.76885 11.4754 4.76171L12.7993 3.42774C12.5566 3.11065 12.2536 2.7776 11.9217 2.46623C11.5828 2.14838 11.2369 1.87478 10.9224 1.67221C10.8981 1.69672 10.8735 1.72151 10.8486 1.74656C10.4718 2.12602 10.0329 2.56801 9.55309 3.05297C9.54973 3.05657 9.54633 3.06015 9.54288 3.0637Z" fill="#1F1F1F"/>
                </svg>
                <span className="mediumLarge">Editor</span>
              </button>
              <button className={classes.vorschauButton} onClick={navigateToStudio}>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path fillRule="evenodd" clipRule="evenodd" d="M4.85133 1H11.1487C11.7652 0.999999 12.2451 0.999997 12.63 1.03145C13.0209 1.06338 13.3384 1.12913 13.6241 1.27466C14.0982 1.51626 14.4837 1.90178 14.7253 2.37594C14.8709 2.66158 14.9366 2.97913 14.9686 3.36997C15 3.75491 15 4.23479 15 4.85132V11.1487C15 11.7652 15 12.2451 14.9686 12.63C14.9366 13.0209 14.8709 13.3384 14.7253 13.6241C14.4837 14.0982 14.0982 14.4837 13.6241 14.7253C13.3384 14.8709 13.0209 14.9366 12.63 14.9686C12.2451 15 11.7652 15 11.1487 15H4.85132C4.23479 15 3.75491 15 3.36997 14.9686C2.97913 14.9366 2.66158 14.8709 2.37594 14.7253C1.90178 14.4837 1.51626 14.0982 1.27466 13.6241C1.12913 13.3384 1.06338 13.0209 1.03145 12.63C0.999997 12.2451 0.999999 11.7652 1 11.1487V4.85133C0.999999 4.23479 0.999997 3.75491 1.03145 3.36997C1.06338 2.97913 1.12913 2.66158 1.27466 2.37594C1.51626 1.90178 1.90178 1.51626 2.37594 1.27466C2.66158 1.12913 2.97913 1.06338 3.36997 1.03145C3.75491 0.999997 4.23479 0.999999 4.85133 1ZM3.41557 1.58959C3.05936 1.61869 2.82371 1.67502 2.63018 1.77363C2.26138 1.96154 1.96154 2.26138 1.77363 2.63018C1.67502 2.82371 1.61869 3.05936 1.58959 3.41557C1.56022 3.77505 1.56 4.23212 1.56 4.864V11.136C1.56 11.7679 1.56022 12.2249 1.58959 12.5844C1.61869 12.9406 1.67502 13.1763 1.77363 13.3698C1.96154 13.7386 2.26138 14.0385 2.63018 14.2264C2.82371 14.325 3.05936 14.3813 3.41557 14.4104C3.77505 14.4398 4.23212 14.44 4.864 14.44H11.136C11.7679 14.44 12.2249 14.4398 12.5844 14.4104C12.9406 14.3813 13.1763 14.325 13.3698 14.2264C13.7386 14.0385 14.0385 13.7386 14.2264 13.3698C14.325 13.1763 14.3813 12.9406 14.4104 12.5844C14.4398 12.2249 14.44 11.7679 14.44 11.136V4.864C14.44 4.23212 14.4398 3.77505 14.4104 3.41557C14.3813 3.05936 14.325 2.82371 14.2264 2.63018C14.0385 2.26138 13.7386 1.96154 13.3698 1.77363C13.1763 1.67502 12.9406 1.61869 12.5844 1.58959C12.2249 1.56022 11.7679 1.56 11.136 1.56H4.864C4.23212 1.56 3.77505 1.56022 3.41557 1.58959Z" fill="#A1A7AE"/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M15 5.76H1V5.2H15V5.76Z" fill="#A1A7AE"/>
                  <path fillRule="evenodd" clipRule="evenodd" d="M6.32 5.76L6.32 15H5.76L5.76 5.76H6.32Z" fill="#A1A7AE"/>
                  <path d="M4.85133 1L4.85133 1.4H4.85133V1ZM11.1487 1V1.4H11.1487L11.1487 1ZM12.63 1.03145L12.5975 1.43012L12.63 1.03145ZM13.6241 1.27466L13.8057 0.918261V0.918261L13.6241 1.27466ZM14.7253 2.37594L14.3689 2.55754V2.55754L14.7253 2.37594ZM14.9686 3.36997L14.5699 3.40254V3.40254L14.9686 3.36997ZM15 4.85132L14.6 4.85132V4.85132H15ZM15 11.1487H14.6V11.1487L15 11.1487ZM14.9686 12.63L14.5699 12.5975L14.9686 12.63ZM14.7253 13.6241L14.3689 13.4425L14.7253 13.6241ZM13.6241 14.7253L13.4425 14.3689L13.6241 14.7253ZM12.63 14.9686L12.5975 14.5699L12.63 14.9686ZM11.1487 15L11.1487 14.6H11.1487V15ZM4.85132 15V14.6H4.85132L4.85132 15ZM3.36997 14.9686L3.40254 14.5699H3.40254L3.36997 14.9686ZM2.37594 14.7253L2.55754 14.3689H2.55754L2.37594 14.7253ZM1.27466 13.6241L0.918261 13.8057H0.918261L1.27466 13.6241ZM1.03145 12.63L0.632777 12.6626L1.03145 12.63ZM1 11.1487L1.4 11.1487V11.1487H1ZM1 4.85133H1.4V4.85133L1 4.85133ZM1.03145 3.36997L1.43012 3.40254L1.03145 3.36997ZM1.27466 2.37594L1.63107 2.55754L1.27466 2.37594ZM2.37594 1.27466L2.55754 1.63107L2.37594 1.27466ZM3.36997 1.03145L3.40254 1.43012L3.36997 1.03145ZM2.63018 1.77363L2.44858 1.41722L2.44858 1.41722L2.63018 1.77363ZM3.41557 1.58959L3.383 1.19092V1.19092L3.41557 1.58959ZM1.77363 2.63018L1.41722 2.44858L1.41722 2.44858L1.77363 2.63018ZM1.58959 3.41557L1.19092 3.383H1.19092L1.58959 3.41557ZM1.58959 12.5844L1.19092 12.617L1.58959 12.5844ZM1.77363 13.3698L2.13003 13.1882H2.13003L1.77363 13.3698ZM2.63018 14.2264L2.81177 13.87L2.63018 14.2264ZM3.41557 14.4104L3.383 14.8091H3.383L3.41557 14.4104ZM12.5844 14.4104L12.617 14.8091H12.617L12.5844 14.4104ZM13.3698 14.2264L13.1882 13.87H13.1882L13.3698 14.2264ZM14.2264 13.3698L13.87 13.1882V13.1882L14.2264 13.3698ZM14.4104 12.5844L14.8091 12.617V12.617L14.4104 12.5844ZM14.4104 3.41557L14.8091 3.383V3.383L14.4104 3.41557ZM14.2264 2.63018L13.87 2.81177L14.2264 2.63018ZM13.3698 1.77363L13.1882 2.13003V2.13003L13.3698 1.77363ZM12.5844 1.58959L12.5519 1.98826L12.5844 1.58959ZM1 5.76H0.6V6.16H1V5.76ZM15 5.76V6.16H15.4V5.76H15ZM1 5.2V4.8H0.6V5.2H1ZM15 5.2H15.4V4.8H15V5.2ZM6.32 15V15.4H6.72V15H6.32ZM6.32 5.76H6.72V5.36H6.32V5.76ZM5.76 15H5.36V15.4H5.76V15ZM5.76 5.76V5.36H5.36V5.76H5.76ZM12.6626 0.632777C12.2577 0.599692 11.7589 0.599999 11.1487 0.6L11.1487 1.4C11.7715 1.4 12.2325 1.4003 12.5975 1.43012L12.6626 0.632777ZM13.8057 0.918261C13.4543 0.739216 13.0782 0.666734 12.6626 0.632777L12.5975 1.43012C12.9635 1.46003 13.2226 1.51904 13.4425 1.63107L13.8057 0.918261ZM15.0817 2.19435C14.8018 1.64491 14.3551 1.19821 13.8057 0.918261L13.4425 1.63107C13.8414 1.83432 14.1657 2.15864 14.3689 2.55754L15.0817 2.19435ZM15.3672 3.3374C15.3333 2.92178 15.2608 2.54574 15.0817 2.19435L14.3689 2.55754C14.481 2.77741 14.54 3.03648 14.5699 3.40254L15.3672 3.3374ZM15.4 4.85132C15.4 4.24112 15.4003 3.74234 15.3672 3.3374L14.5699 3.40254C14.5997 3.76748 14.6 4.22846 14.6 4.85132L15.4 4.85132ZM15.3672 12.6626C15.4003 12.2577 15.4 11.7589 15.4 11.1487L14.6 11.1487C14.6 11.7715 14.5997 12.2325 14.5699 12.5975L15.3672 12.6626ZM15.0817 13.8057C15.2608 13.4543 15.3333 13.0782 15.3672 12.6626L14.5699 12.5975C14.54 12.9635 14.481 13.2226 14.3689 13.4425L15.0817 13.8057ZM13.8057 15.0817C14.3551 14.8018 14.8018 14.3551 15.0817 13.8057L14.3689 13.4425C14.1657 13.8414 13.8414 14.1657 13.4425 14.3689L13.8057 15.0817ZM12.6626 15.3672C13.0782 15.3333 13.4543 15.2608 13.8057 15.0817L13.4425 14.3689C13.2226 14.481 12.9635 14.54 12.5975 14.5699L12.6626 15.3672ZM11.1487 15.4C11.7589 15.4 12.2577 15.4003 12.6626 15.3672L12.5975 14.5699C12.2325 14.5997 11.7715 14.6 11.1487 14.6L11.1487 15.4ZM3.3374 15.3672C3.74234 15.4003 4.24112 15.4 4.85132 15.4L4.85132 14.6C4.22846 14.6 3.76748 14.5997 3.40254 14.5699L3.3374 15.3672ZM2.19435 15.0817C2.54574 15.2608 2.92178 15.3333 3.3374 15.3672L3.40254 14.5699C3.03648 14.54 2.77741 14.481 2.55754 14.3689L2.19435 15.0817ZM0.918261 13.8057C1.19821 14.3551 1.64491 14.8018 2.19435 15.0817L2.55754 14.3689C2.15864 14.1657 1.83432 13.8414 1.63107 13.4425L0.918261 13.8057ZM0.632777 12.6626C0.666734 13.0782 0.739216 13.4543 0.918261 13.8057L1.63107 13.4425C1.51904 13.2226 1.46003 12.9635 1.43012 12.5975L0.632777 12.6626ZM0.6 11.1487C0.599999 11.7589 0.599692 12.2577 0.632777 12.6626L1.43012 12.5975C1.4003 12.2325 1.4 11.7715 1.4 11.1487L0.6 11.1487ZM0.632777 3.3374C0.599692 3.74234 0.599999 4.24112 0.6 4.85133L1.4 4.85133C1.4 4.22846 1.4003 3.76748 1.43012 3.40254L0.632777 3.3374ZM0.918261 2.19435C0.739216 2.54574 0.666734 2.92178 0.632777 3.3374L1.43012 3.40254C1.46003 3.03648 1.51904 2.77741 1.63107 2.55754L0.918261 2.19435ZM2.19435 0.918261C1.64491 1.19821 1.19821 1.64491 0.918261 2.19435L1.63107 2.55754C1.83432 2.15864 2.15864 1.83432 2.55754 1.63107L2.19435 0.918261ZM3.3374 0.632777C2.92178 0.666734 2.54574 0.739216 2.19435 0.918261L2.55754 1.63107C2.77741 1.51904 3.03648 1.46003 3.40254 1.43012L3.3374 0.632777ZM4.85133 0.6C4.24112 0.599999 3.74234 0.599692 3.3374 0.632777L3.40254 1.43012C3.76748 1.4003 4.22846 1.4 4.85133 1.4L4.85133 0.6ZM2.81177 2.13003C2.93949 2.06496 3.11662 2.01535 3.44815 1.98826L3.383 1.19092C3.00211 1.22204 2.70793 1.28508 2.44858 1.41722L2.81177 2.13003ZM2.13003 2.81177C2.27959 2.51824 2.51824 2.27959 2.81177 2.13003L2.44858 1.41722C2.00452 1.64349 1.64349 2.00452 1.41722 2.44858L2.13003 2.81177ZM1.98826 3.44815C2.01535 3.11662 2.06496 2.93949 2.13003 2.81177L1.41722 2.44858C1.28508 2.70793 1.22204 3.00211 1.19092 3.383L1.98826 3.44815ZM1.96 4.864C1.96 4.22546 1.96053 3.78754 1.98826 3.44815L1.19092 3.383C1.15991 3.76256 1.16 4.23879 1.16 4.864H1.96ZM1.96 11.136V4.864H1.16V11.136H1.96ZM1.98826 12.5519C1.96053 12.2125 1.96 11.7745 1.96 11.136H1.16C1.16 11.7612 1.15991 12.2374 1.19092 12.617L1.98826 12.5519ZM2.13003 13.1882C2.06496 13.0605 2.01535 12.8834 1.98826 12.5519L1.19092 12.617C1.22204 12.9979 1.28508 13.2921 1.41722 13.5514L2.13003 13.1882ZM2.81177 13.87C2.51824 13.7204 2.27959 13.4818 2.13003 13.1882L1.41722 13.5514C1.64349 13.9955 2.00452 14.3565 2.44858 14.5828L2.81177 13.87ZM3.44815 14.0117C3.11662 13.9847 2.93949 13.935 2.81177 13.87L2.44858 14.5828C2.70793 14.7149 3.00211 14.778 3.383 14.8091L3.44815 14.0117ZM4.864 14.04C4.22546 14.04 3.78754 14.0395 3.44815 14.0117L3.383 14.8091C3.76256 14.8401 4.23879 14.84 4.864 14.84V14.04ZM11.136 14.04H4.864V14.84H11.136V14.04ZM12.5519 14.0117C12.2125 14.0395 11.7745 14.04 11.136 14.04V14.84C11.7612 14.84 12.2374 14.8401 12.617 14.8091L12.5519 14.0117ZM13.1882 13.87C13.0605 13.935 12.8834 13.9847 12.5519 14.0117L12.617 14.8091C12.9979 14.778 13.2921 14.7149 13.5514 14.5828L13.1882 13.87ZM13.87 13.1882C13.7204 13.4818 13.4818 13.7204 13.1882 13.87L13.5514 14.5828C13.9955 14.3565 14.3565 13.9955 14.5828 13.5514L13.87 13.1882ZM14.0117 12.5519C13.9847 12.8834 13.935 13.0605 13.87 13.1882L14.5828 13.5514C14.7149 13.2921 14.778 12.9979 14.8091 12.617L14.0117 12.5519ZM14.04 11.136C14.04 11.7745 14.0395 12.2125 14.0117 12.5519L14.8091 12.617C14.8401 12.2374 14.84 11.7612 14.84 11.136H14.04ZM14.04 4.864V11.136H14.84V4.864H14.04ZM14.0117 3.44815C14.0395 3.78754 14.04 4.22546 14.04 4.864H14.84C14.84 4.23879 14.8401 3.76256 14.8091 3.383L14.0117 3.44815ZM13.87 2.81177C13.935 2.93949 13.9847 3.11662 14.0117 3.44815L14.8091 3.383C14.778 3.00211 14.7149 2.70793 14.5828 2.44858L13.87 2.81177ZM13.1882 2.13003C13.4818 2.27959 13.7204 2.51824 13.87 2.81177L14.5828 2.44858C14.3565 2.00452 13.9955 1.64349 13.5514 1.41722L13.1882 2.13003ZM12.5519 1.98826C12.8834 2.01535 13.0605 2.06496 13.1882 2.13003L13.5514 1.41722C13.2921 1.28508 12.9979 1.22204 12.617 1.19092L12.5519 1.98826ZM11.136 1.96C11.7745 1.96 12.2125 1.96053 12.5519 1.98826L12.617 1.19092C12.2374 1.15991 11.7612 1.16 11.136 1.16V1.96ZM4.864 1.96H11.136V1.16H4.864V1.96ZM3.44815 1.98826C3.78754 1.96053 4.22546 1.96 4.864 1.96V1.16C4.23879 1.16 3.76256 1.15991 3.383 1.19092L3.44815 1.98826ZM11.1487 0.6H4.85133V1.4H11.1487V0.6ZM15.4 11.1487V4.85132H14.6V11.1487H15.4ZM4.85132 15.4H11.1487V14.6H4.85132V15.4ZM0.6 4.85133V11.1487H1.4V4.85133H0.6ZM1 6.16H15V5.36H1V6.16ZM0.6 5.2V5.76H1.4V5.2H0.6ZM15 4.8H1V5.6H15V4.8ZM15.4 5.76V5.2H14.6V5.76H15.4ZM6.72 15L6.72 5.76H5.92L5.92 15H6.72ZM5.76 15.4H6.32V14.6H5.76V15.4ZM5.36 5.76L5.36 15H6.16L6.16 5.76H5.36ZM6.32 5.36H5.76V6.16H6.32V5.36Z" fill="#A1A7AE"/>
                </svg>
                <span style={{color: "var(--grey-1)"}} className="mediumLarge">Vorschau</span>
              </button>
          </div>
          <div className={classes.overviewMainContent}>
            {!studio ? <div>Wird geladen...</div> : (
              <>
                <OverviewCard title="Studio Status" status={studio?.status} componentId="status" onCardClick={onCardClick} />

                <div className={`${classes.updateContainer} semiboldXxs`}>
                    UPDATES
                </div>
                <OverviewCard updateBox title="Preis & Stundenanzahl" summaryLines={getPricingSummary(studio)} componentId="price" onCardClick={onCardClick} />
                <OverviewCard updateBox title="Stornierungsbedingungen" infos={getCancellationPolicyDisplayName(studio?.cancellationPolicy)} componentId="cancellation" onCardClick={onCardClick} />
                <OverviewCard updateBox title="Hausregeln" componentId="rules" onCardClick={onCardClick} />
                <OverviewCard updateBox title="Kostenpflichtiges Equipment" componentId="equipmentOptional" onCardClick={onCardClick} />

                <OverviewImagesCard processedImages={studio?.processedImages} componentId="fotos" onCardClick={onCardClick}/>
                <OverviewCard title="Titel & Beschreibung" infos={studio?.StudioName} infos2={studio?.description} componentId="titel" onCardClick={onCardClick} />
                <OverviewCard title="Standort & Adresse" address={studio?.address} componentId="standort" onCardClick={onCardClick} />
                <OverviewCard title="Art des Studios" studioTypes={studio.studioTypes} componentId="studioType" onCardClick={onCardClick} />
                <OverviewCard title="Größe und Kapazität" size={studio?.studioSize} capacity={studio?.numberOfPeople} componentId="size" onCardClick={onCardClick} />
                {/* <OverviewCard title="Studio-Tags" componentId="tags" studioTags={studio?.tags} onCardClick={onCardClick} /> */}
                <OverviewCard title="Grundausstattung" componentId="amenities" onCardClick={onCardClick} />
                <OverviewCard title="Kostenloses Equipment" componentId="equipment" onCardClick={onCardClick} />
                <OverviewCard title="Betriebszeiten" componentId="availability" onCardClick={onCardClick} />
              </>
            )}
          </div>
        </div>
        {open && 
            <SmallModal 
                open={open} 
                onBackdropClick={handleClose} 
                fromDeleteStudio={true}
            >
                {modalTab === 1 &&
                    <div className={classes.firstModalTab}>
                        <header className={classes.modalHeader}>
                            <h2 className="titleSemibold3">Studio verwalten</h2>
                            <button onClick={handleClose} className={classes.modalCloseButton}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M7.56773 8.68115L0.5 1.61342L1.43227 0.681152L8.5 7.74888L15.5677 0.681152L16.5 1.61342L9.43227 8.68115L16.5 15.7489L15.5677 16.6812L8.5 9.61342L1.43227 16.6812L0.5 15.7489L7.56773 8.68115Z" fill="#1F1F1F"/>
                                </svg>
                            </button>
                        </header>
                        <Link to={`/calendar`} className={classes.modalOptions}>
                            <span className="mediumLarge">Tage oder Zeiten blockieren</span>
                            <button className={classes.modalOptionButton}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
                                    <path d="M11.5 0.404297V9.10449H10.1006V2.79492L1.9375 10.958L0.947266 9.96777L9.11133 1.80371H2.7998V0.404297H11.5Z" fill="#696F76"/>
                                </svg>
                            </button>
                        </Link>
                        <div onClick={moveToAvailiability} className={classes.modalOptions}>
                            <span className="mediumLarge">Betriebszeiten verwalten</span>
                            <button className={classes.modalOptionButton}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
                                    <path d="M11.5 0.404297V9.10449H10.1006V2.79492L1.9375 10.958L0.947266 9.96777L9.11133 1.80371H2.7998V0.404297H11.5Z" fill="#696F76"/>
                                </svg>
                            </button>
                        </div>
                        <div onClick={() => setModalTab(2)} className={classes.modalOptions}>
                            <div className={classes.deleteStudioTitle}>
                                <h3 style={{color: '#CE425D'}} className="mediumLarge">Studio entfernen</h3>
                                <span style={{color: 'var(--dark-grey-3)'}} className="regularSmall">Studio und Studio-Daten <br/> werden dauerhaft gelöscht.</span>
                            </div>
                            <button className={classes.modalOptionButton}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" viewBox="0 0 9 14" fill="none">
                                    <path d="M8.50039 7.3812L8.10039 7.7812L2.00039 13.8812L0.900391 12.7812L6.30039 7.3812L0.900391 1.5812L2.10039 0.481201L8.50039 7.3812Z" fill="#696F76"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                }
                {modalTab === 2 && 
                    <div className={classes.secondModalTab}>
                        <header className={classes.modalHeader}>
                            <button onClick={handleBackButtonModal}  className={classes.modalBackButton}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M0.851562 8.34137L9.01178 0.181152L10.1019 1.27124L2.98964 8.38348L10.1454 16.1355L9.01257 17.1812L0.867243 8.35705L0.851562 8.34137Z" fill="#1F1F1F"/>
                                </svg>
                            </button>
                            <h2 className="titleSemibold3">Studio entfernen</h2>
                            <button onClick={handleClose} className={classes.modalCloseButton}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M7.56773 8.68115L0.5 1.61342L1.43227 0.681152L8.5 7.74888L15.5677 0.681152L16.5 1.61342L9.43227 8.68115L16.5 15.7489L15.5677 16.6812L8.5 9.61342L1.43227 16.6812L0.5 15.7489L7.56773 8.68115Z" fill="#1F1F1F"/>
                                </svg>
                            </button>
                        </header>
                        <div className={classes.secondMainContainer}>
                            <div className={classes.questionaryContainer}>
                                <h3 className="semiboldMiddle">Wieso möchtest du dein Studio entfernen?</h3>
                                <div className={classes.optionsContainer}>
                                    <div 
                                        className={`${classes.option} ${selectedOption === "not-renting" ? classes.selected : ""}`}
                                        onClick={() => handleOptionSelect("not-renting")}
                                    >
                                        <div className={classes.customCheckbox}>
                                            <div 
                                                className={classes.checkboxOuter}
                                                style={{borderColor: selectedOption === "not-renting" ? "var(--dark-grey)" : ""}}
                                            >
                                                {selectedOption === "not-renting" && <div className={classes.checkboxInner}></div>}
                                            </div>
                                        </div>
                                        <span className="regularMiddle">Ich vermiete dieses Studio nicht mehr.</span>
                                    </div>
                                    <div 
                                        className={`${classes.option} ${selectedOption === "more-bookings" ? classes.selected : ""}`}
                                        onClick={() => handleOptionSelect("more-bookings")}
                                    >
                                        <div className={classes.customCheckbox}>
                                            <div 
                                                className={classes.checkboxOuter}
                                                style={{borderColor: selectedOption === "more-bookings" ? "var(--dark-grey)" : ""}}
                                            >
                                                {selectedOption === "more-bookings" && <div className={classes.checkboxInner}></div>}
                                            </div>
                                        </div>
                                        <span className="regularMiddle">Ich wünsche mir mehr Buchungen.</span>
                                    </div>
                                    <div 
                                        className={`${classes.option} ${selectedOption === "not-suitable" ? classes.selected : ""}`}
                                        onClick={() => handleOptionSelect("not-suitable")}
                                    >
                                        <div className={classes.customCheckbox}>
                                            <div 
                                                className={classes.checkboxOuter}
                                                style={{borderColor: selectedOption === "not-suitable" ? "var(--dark-grey)" : ""}}
                                            >
                                                {selectedOption === "not-suitable" && <div className={classes.checkboxInner}></div>}
                                            </div>
                                        </div>
                                        <span className="regularMiddle">Stu ist nicht die passende Option für mich.</span>
                                    </div>
                                    <div 
                                        className={`${classes.option} ${selectedOption === "other" ? classes.selected : ""}`}
                                        onClick={() => handleOptionSelect("other")}
                                    >
                                        <div className={classes.customCheckbox}>
                                            <div 
                                                className={classes.checkboxOuter} 
                                                style={{borderColor: selectedOption === "other" ? "var(--dark-grey)" : ""}}
                                            >
                                                {selectedOption === "other" && <div className={classes.checkboxInner}></div>}
                                            </div>
                                        </div>
                                        <span className="regularMiddle">Sonstiges.</span>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.textareaContainer}>
                                <div className={classes.titleContainer}>
                                    <h3 className="semiboldMiddle">Wie können wir stu verbessern?</h3>
                                    <h3 className={classes.optionalText}>(Optional)</h3>
                                </div>
                                <textarea
                                    className={`${classes.feedbackTextarea} slimRegularLargeText`}
                                    value={textareaContent}
                                    onChange={handleTextareaChange}
                                    maxLength={300}
                                />
                                <div className={`${classes.characterCount} slimRegularSmallText`}>
                                    {textareaContent.length}/300
                                </div>
                            </div>
                        </div>
                        <footer className={classes.modalFooter}>
                            <button 
                                className={`${classes.cancelButton} mediumLarge`}
                                onClick={handleBackButtonModal}
                            >
                                Abbrechen
                            </button>
                            <button 
                                onClick={() => setModalTab(3)}
                                className={`${classes.continueButton} mediumLarge ${!selectedOption ? classes.disabled : ""}`}
                                disabled={!selectedOption}
                            >
                                Weiter
                            </button>
                        </footer>
                    </div>
                }
                {modalTab === 3 &&
                    <div className={classes.thirdModalTab}>
                        <header className={classes.thirdModalHeader}>
                            <h2 className="titleSemibold3">Studio entfernen</h2>
                            <button onClick={handleClose} className={classes.modalCloseFinalButton}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M8.00947 8.68115L0.5 1.17169L1.49054 0.181152L9 7.69062L16.5095 0.181152L17.5 1.17169L9.99054 8.68115L17.5 16.1906L16.5095 17.1812L9 9.67169L1.49054 17.1812L0.5 16.1906L8.00947 8.68115Z" fill="#1F1F1F"/>
                                </svg>
                            </button> 
                        </header>
                        <span className={classes.deleteText}>Studio und Studio-Daten <br/> werden dauerhaft gelöscht.</span>
                        <div className={classes.deleteButtonContainer}>
                            <button 
                                onClick={handleArchiveStudio} 
                                className={`${classes.finalDeleteButton} mediumLarge`}
                                disabled={archiveLoading || fetchingStudio}
                            >
                                {(archiveLoading || fetchingStudio) ? 'Wird verarbeitet...' : 'Studio entfernen'}
                            </button>
                            <button onClick={() => setModalTab(2)} className={`${classes.finalButtonAbbort} mediumLarge`}>Abbrechen</button>
                        </div>
                    </div>
                }
                {modalTab === 4 &&
                    <div className={classes.successModalTab}>
                        <header className={classes.successModalHeader}>
                            <div className={classes.successModalIcon}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="17" height="13" viewBox="0 0 17 13" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M16.8237 1.18765L5.13496 12.3054L5.13474 12.3052L5.13364 12.3063L0.175781 7.24179L1.29183 6.14924L5.17296 10.1139L15.7473 0.0559998L16.8237 1.18765Z" fill="white"/>
                                </svg>
                            </div>
                            <h2 className="titleSemibold3">Dein Studio wurde entfernt</h2>
                        </header>
                        <p className={`${classes.successText} regularSmall`}>
                             Danke für dein Vertrauen in unser Produkt. <br/> Wir hoffen, dich weiterhin begleiten.
                         </p>
                        <button onClick={handleFinish} 
                            className={`${classes.navigateButton} mediumLarge`}>
                            Fertig
                        </button>
                    </div>
                }
                {modalTab === 5 &&
                    <div className={classes.bookingConflictTab}>
                        <div className={classes.bookingConflictContent}>
                            <div className={classes.bookingConflictIconContainer}>
                                <div className={classes.warningIcon}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 60 60" fill="none">
                                        <path d="M30 15V35M30 45H30.01" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                                <h3 className="semiboldMiddle">
                                    Du hast noch offene Buchungen
                                </h3>
                            </div>
                            <p className={`regularMiddle ${classes.warningText}`}>
                                Dein Studio kann nicht entfernt werden, da noch zukünftige Buchungen vorhanden sind. 
                                Bitte warte bis alle Buchungen abgeschlossen sind oder kontaktiere den Support.
                            </p>
                        </div>
                        <button onClick={() => setModalTab(3)} className={`${classes.backToDeleteButton} mediumLarge`}>Zurück</button>
                    </div>
                }
            </SmallModal>
        }
        {openPhoneModal &&
            <div className={classes.phoneModal}>
                {modalTab === 1 &&
                    <div className={classes.firstModalTab}>
                        <header className={classes.modalHeader}>
                            <h2 className="titleSemibold3">Studio verwalten</h2>
                            <button onClick={() => setOpenPhoneModal(false)} className={classes.modalCloseButton}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="21" viewBox="0 0 12 21" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M11.8379 19.5669L10.3078 20.9941L0.337891 10.0749L10.3078 -0.00585938L11.7787 1.48131L3.22029 10.1348L11.8379 19.5669Z" fill="#101010"/>
                                </svg>
                            </button>
                        </header>
                        <Link to={`/calendar`} className={classes.modalOptions}>
                            <span className="mediumLarge">Tage oder Zeiten blockieren</span>
                            <button className={classes.modalOptionButton}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
                                    <path d="M11.5 0.404297V9.10449H10.1006V2.79492L1.9375 10.958L0.947266 9.96777L9.11133 1.80371H2.7998V0.404297H11.5Z" fill="#696F76"/>
                                </svg>
                            </button>
                        </Link>
                        <div onClick={moveToAvailiability} className={classes.modalOptions}>
                            <span className="mediumLarge">Betriebszeiten verwalten</span>
                            <button className={classes.modalOptionButton}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="none">
                                    <path d="M11.5 0.404297V9.10449H10.1006V2.79492L1.9375 10.958L0.947266 9.96777L9.11133 1.80371H2.7998V0.404297H11.5Z" fill="#696F76"/>
                                </svg>
                            </button>
                        </div>
                        <div onClick={() => setModalTab(2)} className={classes.modalOptions}>
                            <div className={classes.deleteStudioTitle}>
                                <h3 style={{color: '#CE425D'}} className="mediumLarge">Studio entfernen</h3>
                                <span style={{color: 'var(--dark-grey-3)'}} className="regularSmall">Studio und Studio-Daten <br/> werden dauerhaft gelöscht.</span>
                            </div>
                            <button className={classes.modalOptionButton}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="14" viewBox="0 0 9 14" fill="none">
                                    <path d="M8.50039 7.3812L8.10039 7.7812L2.00039 13.8812L0.900391 12.7812L6.30039 7.3812L0.900391 1.5812L2.10039 0.481201L8.50039 7.3812Z" fill="#696F76"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                }
                {modalTab >= 2 && 
                    <div className={classes.secondModalTab}>
                        <header className={classes.modalHeader}>
                            <button onClick={handleBackButtonModal}  className={classes.modalBackButton}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="18" viewBox="0 0 11 18" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M0.851562 8.34137L9.01178 0.181152L10.1019 1.27124L2.98964 8.38348L10.1454 16.1355L9.01257 17.1812L0.867243 8.35705L0.851562 8.34137Z" fill="#1F1F1F"/>
                                </svg>
                            </button>
                            <h2 className="titleSemibold3">Studio entfernen</h2>
                        </header>
                        <div className={classes.secondMainContainer}>
                            <div className={classes.questionaryContainer}>
                                <h3 className="semiboldMiddle">Wieso möchtest du dein Studio entfernen?</h3>
                                <div className={classes.optionsContainer}>
                                    <div 
                                        className={`${classes.option} ${selectedOption === "not-renting" ? classes.selected : ""}`}
                                        onClick={() => handleOptionSelect("not-renting")}
                                    >
                                        <div className={classes.customCheckbox}>
                                            <div 
                                                className={classes.checkboxOuter}
                                                style={{borderColor: selectedOption === "not-renting" ? "var(--dark-grey)" : ""}}
                                            >
                                                {selectedOption === "not-renting" && <div className={classes.checkboxInner}></div>}
                                            </div>
                                        </div>
                                        <span className="regularMiddle">Ich vermiete dieses Studio nicht mehr.</span>
                                    </div>
                                    <div 
                                        className={`${classes.option} ${selectedOption === "more-bookings" ? classes.selected : ""}`}
                                        onClick={() => handleOptionSelect("more-bookings")}
                                    >
                                        <div className={classes.customCheckbox}>
                                            <div 
                                                className={classes.checkboxOuter}
                                                style={{borderColor: selectedOption === "more-bookings" ? "var(--dark-grey)" : ""}}
                                            >
                                                {selectedOption === "more-bookings" && <div className={classes.checkboxInner}></div>}
                                            </div>
                                        </div>
                                        <span className="regularMiddle">Ich wünsche mir mehr Buchungen.</span>
                                    </div>
                                    <div 
                                        className={`${classes.option} ${selectedOption === "not-suitable" ? classes.selected : ""}`}
                                        onClick={() => handleOptionSelect("not-suitable")}
                                    >
                                        <div className={classes.customCheckbox}>
                                            <div 
                                                className={classes.checkboxOuter}
                                                style={{borderColor: selectedOption === "not-suitable" ? "var(--dark-grey)" : ""}}
                                            >
                                                {selectedOption === "not-suitable" && <div className={classes.checkboxInner}></div>}
                                            </div>
                                        </div>
                                        <span className="regularMiddle">Stu ist nicht die passende Option für mich.</span>
                                    </div>
                                    <div 
                                        className={`${classes.option} ${selectedOption === "other" ? classes.selected : ""}`}
                                        onClick={() => handleOptionSelect("other")}
                                    >
                                        <div className={classes.customCheckbox}>
                                            <div 
                                                className={classes.checkboxOuter} 
                                                style={{borderColor: selectedOption === "other" ? "var(--dark-grey)" : ""}}
                                            >
                                                {selectedOption === "other" && <div className={classes.checkboxInner}></div>}
                                            </div>
                                        </div>
                                        <span className="regularMiddle">Sonstiges.</span>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.textareaContainer}>
                                <div className={classes.titleContainer}>
                                    <h3 className="semiboldMiddle">Wie können wir stu verbessern?</h3>
                                    <h3 className={classes.optionalText}>(Optional)</h3>
                                </div>
                                <textarea
                                    className={`${classes.feedbackTextarea} slimRegularLargeText`}
                                    value={textareaContent}
                                    onChange={handleTextareaChange}
                                    maxLength={300}
                                />
                                <div className={`${classes.characterCount} slimRegularSmallText`}>
                                    {textareaContent.length}/300
                                </div>
                            </div>
                        </div>
                        <footer className={classes.modalFooter}>
                            <button 
                                className={`${classes.cancelButton} mediumLarge`}
                                onClick={handleBackButtonModal}
                            >
                                Abbrechen
                            </button>
                            <button 
                                onClick={() => setModalTab(3)}
                                className={`${classes.continueButton} mediumLarge ${!selectedOption ? classes.disabled : ""}`}
                                disabled={!selectedOption}
                            >
                                Weiter
                            </button>
                        </footer>
                    </div>
                }
                {modalTab === 3 &&
                    <div className={classes.modalWrapper}>
                        <div className={classes.thirdModalTab}>
                            <header className={classes.thirdModalHeader}>
                                <h2 className="titleSemibold3">Studio entfernen</h2>
                                <button onClick={handleClose} className={classes.modalCloseFinalButton}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M8.00947 8.68115L0.5 1.17169L1.49054 0.181152L9 7.69062L16.5095 0.181152L17.5 1.17169L9.99054 8.68115L17.5 16.1906L16.5095 17.1812L9 9.67169L1.49054 17.1812L0.5 16.1906L8.00947 8.68115Z" fill="#1F1F1F"/>
                                    </svg>
                                </button> 
                            </header>
                            <span className={classes.deleteText}>Studio und Studio-Daten <br/> werden dauerhaft gelöscht.</span>
                            <div className={classes.deleteButtonContainer}>
                                <button 
                                    onClick={handleArchiveStudio} 
                                    className={`${classes.finalDeleteButton} mediumLarge`}
                                    disabled={archiveLoading || fetchingStudio}
                                >
                                    {(archiveLoading || fetchingStudio) ? 'Wird verarbeitet...' : 'Studio entfernen'}
                                </button>
                                <button onClick={() => setModalTab(2)} className={`${classes.finalButtonAbbort} mediumLarge`}>Abbrechen</button>
                            </div>
                        </div>
                    </div>
                }
                {modalTab === 4 &&
                    <div className={classes.modalWrapper}>
                        <div className={classes.successModalTab}>
                            <header className={classes.successModalHeader}>
                                <div className={classes.successModalIcon}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="13" viewBox="0 0 17 13" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M16.8237 1.18765L5.13496 12.3054L5.13474 12.3052L5.13364 12.3063L0.175781 7.24179L1.29183 6.14924L5.17296 10.1139L15.7473 0.0559998L16.8237 1.18765Z" fill="white"/>
                                    </svg>
                                </div>
                                <h2 className="titleSemibold3">Dein Studio wurde entfernt</h2>
                            </header>
                                                    <p className={`${classes.successText} regularSmall`}>
                                Danke für dein Vertrauen in unser Produkt. <br/> Wir hoffen, dich weiterhin begleiten.
                            </p>
                            <button onClick={handleFinish} 
                                className={`${classes.navigateButton} mediumLarge`}>
                                Fertig
                            </button>
                        </div>
                    </div>
                }
                {modalTab === 5 &&
                    <div className={classes.modalWrapper}>
                        <div className={classes.bookingConflictTab}>
                            <div className={classes.bookingConflictContent}>
                                <div className={classes.bookingConflictIconContainer}>
                                    <div className={classes.warningIcon}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 60 60" fill="none">
                                            <path d="M30 15V35M30 45H30.01" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
                                        </svg>
                                    </div>
                                    <h3 className="semiboldMiddle">
                                        Du hast noch offene Buchungen
                                    </h3>
                                </div>
                                <p className={`regularMiddle ${classes.warningText}`}>
                                    Dein Studio kann nicht entfernt werden, da noch zukünftige Buchungen vorhanden sind. 
                                    Bitte warte bis alle Buchungen abgeschlossen sind oder kontaktiere den Support.
                                </p>
                            </div>
                            <button onClick={() => setModalTab(3)} className={`${classes.backToDeleteButton} mediumLarge`}>Zurück</button>
                        </div>
                    </div>
                } 
            </div>
        }
    </div>
    )
};

export default Overview;
